import { render, staticRenderFns } from "./ChatBoxSuporte.vue?vue&type=template&id=6fa2277d&scoped=true"
import script from "./ChatBoxSuporte.vue?vue&type=script&lang=js"
export * from "./ChatBoxSuporte.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxSuporte.vue?vue&type=style&index=0&id=6fa2277d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa2277d",
  null
  
)

export default component.exports